/**
 * `RoomConfig` — backend.md §7.4, transcribed. The room is created from it in
 * M3; the lobby form, the REST lobby mirror and `GET /api/config` all read it
 * now.
 */
import { z } from 'zod';
import { paceTierSchema } from './pace.js';
export const VARIANTS = ['8r', '4r'];
export const variantSchema = z.enum(VARIANTS);
export const SENAS_MODES = ['off', 'private', 'catchable'];
export const senasModeSchema = z.enum(SENAS_MODES);
export const TARGET_POINTS = [40, 30];
export const VACA_BEST_OF = [3, 5];
export const roomConfigSchema = z.object({
    name: z.string().trim().min(1).max(32),
    isPrivate: z.boolean().default(false),
    variant: variantSchema.default('8r'),
    targetPoints: z.union([z.literal(40), z.literal(30)]).default(40),
    vaca: z.boolean().default(false),
    vacaBestOf: z.union([z.literal(3), z.literal(5)]).default(3),
    paceTier: paceTierSchema.default('normal'),
    senasMode: senasModeSchema.default('private'),
    senasCatchPct: z.number().int().min(0).max(100).default(25),
    botsAllowed: z.boolean().default(false),
});
/** Leader edits arrive as a patch; `name` is the only field without a default. */
export const roomConfigPatchSchema = roomConfigSchema.partial();
export function defaultRoomConfig(name) {
    return roomConfigSchema.parse({ name });
}
/**
 * Derived, never stored on the config: an untimed table or one that ever held a
 * bot cannot be ranked (decisions.md, backend.md §3.7).
 */
export function isRanked(config, hadBots) {
    return config.paceTier !== 'sinReloj' && !hadBots;
}
//# sourceMappingURL=room-config.js.map